export function calculatePackageDimensions(cartItems) {
    let smallCount = 0;
    let largeCount = 0;
    // Count small and large items
    for (const item of cartItems) {
        if (item.productSize === 'small') {
          smallCount += item.quantity;
        } else if (item.productSize === 'large') {
          largeCount += item.quantity;
        }
    }
  
    // Determine package type
    let packageType = '';
    if (largeCount >= 2 || (largeCount === 1 && smallCount >= 8)) {
        packageType = 'xlargeBox';
    } else if (
        largeCount === 1 ||
        smallCount >= 4
    ) {
        packageType = 'largeBox';
    } else {
        packageType = 'polyBag';
    }
  
    // Define dimensions
    const packageDimensions = {
        polyBag: {
            length: 13.5,
            width: 9.5,
            height: 2,
            weight: 0.025,
        },
        largeBox: {
            length: 20,
            width: 15,
            height: 6,
            weight: 3.2,
        },
        xlargeBox: {
            length: 20,
            width: 15,
            height: 12,
            weight: 3.5,
        },
    };
  
    return {
        packageType,
        ...packageDimensions[packageType]
    };
}
  